import { App } from '@graphistry/viz/src/components/app';
import { View } from '@graphistry/viz/src/containers/view';
import { User } from '@graphistry/viz/src/containers/user';
import { Scheduler } from '@reactivex/rxjs';
import { connect, container } from '@graphistry/falcor-react-redux';
import { createLogger } from '@graphistry/common/logger';

const logger = createLogger(__filename);

const withAppContainer = container({
    renderLoading: true,
    fragment: ({ workbooks = [], currentUser = {}, ...rest } = {}) => {
        //console.debug({workbooks, currentUser, rest}, 'app.container');
        return `{
            workbooks: {
                length, open: {
                    id, title, views: {
                        length, current: ${View.fragment(
                            (workbooks &&
                                workbooks.open &&
                                workbooks.open.views &&
                                workbooks.open.views.current) ||
                                undefined
                        )}
                    }
                }
            },
            currentUser: ${User.fragment(currentUser)},
            flags: { flag_share_modal, flag_gfql_download, flag_talk2graph }
        }`;
    }
});

let AppContainer = withAppContainer(({ workbooks = {}, currentUser, flags, ...props }) => {
    console.debug({workbooks, currentUser, flags, props}, '@withAppContainer');
    const view = workbooks && workbooks.open && workbooks.open.views && workbooks.open.views.current;
    return (<App {...props} view={view}>{view ? <View key='view' user={currentUser} flags={flags} data={view}/> : undefined}</App>);
});

AppContainer = connect(AppContainer, Scheduler.animationFrame);

export { AppContainer as App };
export default AppContainer;
